import { createSelector } from '@ngrx/store';

import { loyaltyIntroductionPagesState } from '../root';

export const getLoyaltyIntroductionPages = createSelector(loyaltyIntroductionPagesState, (loyaltyIntroductionPages) => loyaltyIntroductionPages);
